<template>
	<div>
		<v-flex offset-md8 offset-sm6 offset-xs1>
			<customer-expense
				class="location-component"
				label="GASTO TOTAL"
				:amount="customerAmount"
			/>
		</v-flex>
		<v-tabs grow class="checkin-tabs pos-tabs" v-model="activeTab">
			<v-tabs-bar class="transparent">
				<v-tabs-slider class="default-skyblue"></v-tabs-slider>
				<v-tabs-item
					v-for="tab in tabs"
					:key="tab.id"
					:href="`#tab-${tab.id}`"
				>
					{{ tab.title }}
				</v-tabs-item>
			</v-tabs-bar>
			<v-tabs-items>
				<v-tabs-content id="tab-1">
					<customer-details
						v-if="detailsActive"
						:customer-info="currentCustomer"
					/>
				</v-tabs-content>
				<v-tabs-content id="tab-2">
					<statistics v-if="statisticsActive"/>
				</v-tabs-content>
				<v-tabs-content id="tab-3">
					<record v-if="recordActive"/>
				</v-tabs-content>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
import customerExpense from './subComponents/Customer-expense';
import customerDetails from './subComponents/Customer-Details';
import statistics from './subComponents/Statistics';
import record from './subComponents/Record';

function created() {
	if (this.$route.query) {
		this.customerAmount = this.$route.query.amountPayment;
		this.customerId = this.$route.query.customerId;
		if (this.$route.query.tab) {
			this.activeTab = `tab-${this.$route.query.tab}`;
		}
		this.loadData();
	}
}

async function loadData() {
	const url = `${process.env.PMS_URL}/customers-commercial-type/${this.customerId}`;
	const { data: customer } = await this.$http.get(url);
	this.currentCustomer = customer.data;
}

function detailsActive() {
	return this.activeTab === 'tab-1';
}

function recordActive() {
	return this.activeTab === 'tab-3';
}

function statisticsActive() {
	return this.activeTab === 'tab-2';
}

function data() {
	return {
		activeTab: 'tab-1',
		currentCustomer: {},
		tabs: [
			{ id: 1, title: 'Detalle' },
			{ id: 2, title: 'Estadística' },
			{ id: 3, title: 'Historial' },
		],
		customerAmount: 0,
	};
}

export default {
	name: 'new-customer',
	components: {
		customerDetails,
		customerExpense,
		record,
		statistics,
	},
	computed: {
		detailsActive,
		recordActive,
		statisticsActive,
	},
	created,
	data,
	methods: {
		loadData,
	},
};
</script>

<style lang="scss" scoped>
	.location-component {
		position: absolute;
	}	
</style>



// WEBPACK FOOTER //
// New-Customer.vue?62f467cc